module.exports = __webpack_public_path__ + "static/media/ngosvg.cb4855da.svg";